import React from 'react';
import ContactView from './ContactView';

const ContactViewForCreation: React.FC = () => (
  <ContactView initialMode="create" />
);

export default ContactViewForCreation;
